import { useMemo } from "react";

import { BAAService } from "../../services";
import type { APIInstance } from "../../services/apiService";

export const useBAAService = (api: APIInstance) => {
  return useMemo(() => new BAAService(api), [api]);
};
